import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import PropTypes from 'prop-types';

const NotesSection = ({ id }) => {
  const isMobile = useMediaBreakpoint('sm-down');
  return (
    <div className="flex flex-row margin-b">
      <p className={clsx(isMobile ? 'dls-gray-02-bg' : 'dls-gray-01-bg', ' body-xsmall pad-1 radius-container-sm width-full')}>
        <FormattedMessage id={id} />
      </p>
    </div>
  );
};

NotesSection.propTypes = {
  id: PropTypes.string.isRequired,
};

export default NotesSection;
